<template>
  <div class="exam-paper">
    <!-- <audio
      :src="MusicBg"
      loop
      autoplay
      style="display: none;"
    /> -->
    <img
      class="title"
      src="@/assets/images/exam-paper-title-1.png"
      alt=""
      draggable="false"
    >
    <div
      class="introduction"
    >
      <p>在这里，你将扮演一位杰出的助农专家，与广大农民一同携手迎接农业的挑战。</p>
      <p>
        通过回答问题，你将为农民刘大叔提供宝贵的建议，帮助他实现丰收和提高收入。你的农业智慧将在这片土地上开花结果，让我们一同踏上这场充满知识和农耕乐趣的冒险吧！
      </p>
    </div>
    <!-- 底部按钮 -->
    <button
      class="start"
      @click="router.push({
        name: 'ExamPaper2',
      })"
    >
      开始答题
    </button>
  </div>
</template>

<script setup>
import useSizeAdapt from "@/useFunctions/useSizeAdapt"
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"
import dayjs from 'dayjs'
import { shuffle } from 'lodash'

// import MusicBg from '@/assets/audio/1.mp3'

const route = useRoute()
const router = useRouter()
const store = useStore()

const {
  windowSizeInCssForRef,
  windowSizeWhenDesignForRef,
} = useSizeAdapt(390, 752)
</script>

<style lang="less" scoped>
.exam-paper{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: url(@/assets/images/exam-paper-bg-1.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;
  >img.title{
    position: absolute;
    left: 50%;
    top: calc(37 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    width: calc(282 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    height: calc(129 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
  }
  >.introduction{
    position: absolute;
    left: 50%;
    top: calc(215 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    width: calc(295 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    height: calc(313 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-size: calc(16 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 1.5;
    >p{
      margin-bottom: 1em;
    }
  }
  >button.start{
    position: absolute;
    left: 50%;
    bottom: calc(59 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    width: calc(300 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    height: calc(70 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    background-image: url(@/assets/images/exam-paper-btn-long-bg.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    font-size: calc(24 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: 800;
    color: #FFFFFF;
    line-height: calc(28 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    padding-bottom: calc(6 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
  }
}
</style>